import GenericTracker from "./generic-tracker";
import GtmTracker from "./gtm-tracker";
import DataTracker from "./data-tracker";
import IdentifyTracker from "./identify-tracker";
import { EVENT_TYPE } from "./global-event";

const trackers: any = {}

export function getTracker(type: EVENT_TYPE) {
    let typeIndex: string = <string> type,
        tracker: any = trackers[typeIndex];

    if (!tracker) {
        switch (type) {
            case EVENT_TYPE.GTM:
                tracker = new GtmTracker();
                break;
            case EVENT_TYPE.DATA:
                tracker = new DataTracker();
                break;
            case EVENT_TYPE.IDENTIFY:
                tracker = new IdentifyTracker();
                break;
            case EVENT_TYPE.GENERIC:
            default:  
                tracker = new GenericTracker();
                
        }
        trackers[typeIndex] = tracker;
    }

    return tracker;
}